import React from 'react';

class OptInCopyPanel extends React.Component {

    constructor(props) {

        super();
        this.state = {
            copy: props.copy
        };

        this.fieldUpdateMethods = {
            copy: props.onCopyUpdated
        };

        this.onKeyPressedGen = this.onKeyPressedGen.bind(this);
        this.onClickGen = this.onClickGen.bind(this);
    }

    onKeyPressedGen(fieldName) {
        return (e) => {
            return this.setState({ [fieldName]: e.target.value });
        };
    }

    onClickGen(fieldName) {
        return (e) => {
            return this.fieldUpdateMethods[fieldName](this.state[fieldName]);
        };
    }

    render() {

        return (
            <div className="row" style={{ marginTop: '0.5rem' }}>
                <div className="col-12">
                    <span className="text-left" style={{ fontSize: '0.85rem' }}>
                        <strong>{this.props.title}</strong>
                    </span>
                    <div style={{ marginTop: '0.25rem' }}>
                        <em>Consent Copy</em>
                    </div>
                    <div className="row">
                        <div className="col-10">
                            <textarea className="form-control" rows="2" value={this.state.copy || ""} onChange={this.onKeyPressedGen('copy')} />
                        </div>
                        <div className="col-2">
                            <button className="btn btn-small btn-default" onClick={this.onClickGen('copy')}><i className="fas fa-check"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OptInCopyPanel;
